import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AutomationModule } from '@frontend/sports/automation/core-feature';
import { FontResizerComponent } from '@frontend/sports/common/core/feature/font-resizer';
import { ScrollAdapterComponent } from '@frontend/sports/common/core/feature/scroll-adapter';
import { ColoredIconComponent } from '@frontend/sports/common/ui/colored-icon';
import { SportsThemedButtonDirective } from '@frontend/sports/common/ui/sports-themed-button';
import { LinkDirective } from '@frontend/sports/common/ui/sports-themed-pills';
import { SportsThemedTabsDirective } from '@frontend/sports/common/ui/sports-themed-tab-group';
import { CompetitionLogoComponent } from '@frontend/sports/competition-logos/feature';
import { GestureModule } from '@frontend/sports/gesture/feature';
import { PerformanceTrackerComponent } from '@frontend/sports/tracking/feature/performance-tracker';
import { DsButton } from '@frontend/ui/button';
import { DsNotificationBubble } from '@frontend/ui/notification-bubble';
import { DsPill } from '@frontend/ui/pill';
import { DsTabsModule } from '@frontend/ui/tabsgroup';
import { SpeculativeLinkDirective } from '@frontend/vanilla/features/speculative-link';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { EffectsModule } from '@ngrx/effects';
import { RxIf } from '@rx-angular/template/if';
import { DynamicComponent, DynamicIoDirective } from 'ng-dynamic-component';

import { CalendarItemListComponent } from '../calendar/calendar-item-list.component';
import { ShowInEpcotDirective } from '../common/epcot-config.directive';
import { ErrorComponent } from '../common/error/error.component';
import { HeadingComponent } from '../common/heading.component';
import { ItemComponent } from '../common/item/item.component';
import { CrmPromotionModule } from '../crm-promotion/crm-promotion.module';
import { ComponentLoaderComponent } from '../deferred/component-loader.component';
import { ComponentProxyDirective } from '../deferred/component-proxy.directive';
import { DirectivesModule } from '../directives/directives.module';
import { ScrollSelectedInViewDirective } from '../directives/scroll-selected-in-view/scroll-selected-in-view.directive';
import { FavouritesModule } from '../favourites/favourites.module';
import { GridScoreboardModule } from '../grid-scoreboard/grid-scoreboard.module';
import { GridModule } from '../grid/grid.module';
import { EventGroupComponent } from '../grid/header/event-group.component';
import { NavigationCoreModule } from '../navigation-core/navigation-core.module';
import { NavigationModule } from '../navigation/navigation.module';
import { OptionGroupRendererDirective } from '../option-group/option-group-renderer.directive';
import { PriceBoostModule } from '../priceboost/price-boost.module';
import { ShowcaseModule } from '../showcase/showcase.module';
import { TabBarModule } from '../tab-bar/tab-bar.module';
import { BetBuilderEventListComponent } from './coupons/bet-builder/betbuilder-event-list.component';
import { PromotedBetBuilderComponent } from './coupons/bet-builder/promoted-betbuilder.component';
import { CouponEventComponent } from './coupons/coupon-event.component';
import { CouponGridComponent } from './coupons/coupon-grid.component';
import { CouponGridEffects } from './coupons/coupon-grid.epic';
import { CouponListComponent } from './coupons/coupon-list.component';
import { CouponComponent } from './coupons/coupon.component';
import { FormCouponHeaderComponent } from './coupons/form-coupon/form-coupon-header.component';
import { FormCouponQuickSelectorsComponent } from './coupons/form-coupon/form-coupon-quick-selectors.component';
import { CalendarCompetitionTreeModalDialogService } from './sport/calendar-competition-tree-modal-dialog.service';
import { CompetitionHeaderWidgetComponent } from './sport/competition-header-widget.component';
import { CompetitionTeamsWidgetComponent } from './sport/competition-teams-widget.component';
import { CompetitionGridTrackingEffects } from './sport/competitions/competition-grid-tracking.epic';
import { CompetitionGridEffects } from './sport/competitions/competition-grid.epic';
import { FixtureListHeaderComponent } from './sport/fixture-list-header.component';
import { FixtureListMenuComponent } from './sport/fixture-list-menu.component';
import { RewardTokenEligibleTagComponent } from './sport/reward-token-eligible-tag.component';
import { TournamentGroupsParticipantsComponent } from './sport/tournament-groups-participants.component';
import { TournamentGroupsComponent } from './sport/tournament-groups.component';
import { TournamentComponent } from './tournament/tournament.component';

@NgModule({
    imports: [
        CommonModule,
        RxIf,
        GridModule,
        CalendarItemListComponent,
        TabBarModule,
        CrmPromotionModule,
        ShowcaseModule,
        FavouritesModule,
        CompetitionLogoComponent,
        DirectivesModule,
        NavigationCoreModule,
        NavigationModule,
        ComponentProxyDirective,
        EffectsModule.forFeature([CouponGridEffects, CompetitionGridTrackingEffects, CompetitionGridEffects]),
        GestureModule,
        GridScoreboardModule,
        PriceBoostModule,
        AutomationModule,
        DynamicComponent,
        DynamicIoDirective,
        PerformanceTrackerComponent,
        ColoredIconComponent,
        ErrorComponent,
        ShowInEpcotDirective,
        ItemComponent,
        FontResizerComponent,
        HeadingComponent,
        ScrollAdapterComponent,
        OptionGroupRendererDirective,
        RewardTokenEligibleTagComponent,
        PromotedBetBuilderComponent,
        BetBuilderEventListComponent,
        CouponListComponent,
        TournamentGroupsComponent,
        CompetitionTeamsWidgetComponent,
        TournamentGroupsParticipantsComponent,
        ComponentLoaderComponent,
        ScrollSelectedInViewDirective,
        FixtureListMenuComponent,
        IconCustomComponent,
        SportsThemedButtonDirective,
        DsButton,
        DsPill,
        FixtureListHeaderComponent,
        DsTabsModule,
        DsNotificationBubble,
        LinkDirective,
        SpeculativeLinkDirective,
        SportsThemedTabsDirective,
        CouponEventComponent,
        EventGroupComponent,
    ],
    declarations: [
        CouponComponent,
        FormCouponHeaderComponent,
        TournamentComponent,
        FormCouponQuickSelectorsComponent,
        CouponGridComponent,
        CompetitionHeaderWidgetComponent,
    ],
    exports: [
        BetBuilderEventListComponent,
        CouponComponent,
        CouponListComponent,
        FixtureListHeaderComponent,
        FormCouponHeaderComponent,
        TournamentGroupsComponent,
        TournamentComponent,
        CouponEventComponent,
        CouponGridComponent,
    ],
    providers: [CalendarCompetitionTreeModalDialogService],
})
export class EventListSharedModule {}
